<template>
  <Button icon="pi pi-compass" class="p-button-warning mr-2"
          @click="showConfirmDialog"
          v-if="isButtonVisible"
          v-tooltip.top="t('action.ripianificazione-operativa')"/>
</template>

<script setup>
import {ref} from "vue";
import pianificazioneRestService from "@/services/PianificazioneRestService";
import {useI18n} from "vue-i18n";
import {onMounted, onUnmounted} from "vue";
import EventService from "@/services/EventService";
import {WORKFLOW_NOTIFICATION} from "@/components/common/constants/Events";
import {useConfirm} from "primevue/useconfirm";


const props = defineProps({viaggio: {type: Object, required: true}});

const {t} = useI18n();
const confirm = useConfirm();

const isButtonVisible = ref(false);

onMounted(() => {
  checkButtonVisibility();
  EventService.on(WORKFLOW_NOTIFICATION, checkButtonVisibility);
})

onUnmounted(() => {
  EventService.off(WORKFLOW_NOTIFICATION, checkButtonVisibility);
})

const showConfirmDialog = () => {
  confirm.require({
    header: t('message.generic-confirm.header'),
    message: t('message.planning-reopen-confirm'),
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      pianificazioneRestService.riapriPianificazioneOperativa(props.viaggio.codice);
    },
    reject: () => {
    }
  });
}

const checkButtonVisibility = async () => {
  const isInParentTreeTable = props.viaggio.parent;
  if (isInParentTreeTable) {
    isButtonVisible.value = await pianificazioneRestService.isRipianificazioneOperativaAttivabile(props.viaggio.codice);
  }
}

</script>

<style scoped>

</style>
